import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import axios from "axios";
import Swal from "sweetalert2";
import { formatToDateTime, formatToDateTime1 } from "./main/formatToDateTime";

export default function StrategyWarehouse() {
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Warehouse, setWarehouse] = useState(null);
  const [jobType, setJobType] = useState(null);
  const [jobTypeFilter, setJobTypeFilter] = useState("1");
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    let warehouse = searchParams.get("warehouse");
    let job_type = searchParams.get("job_type");
    if (!warehouse) {
      setSearchParams({ warehouse: "Import" }, { replace: true });
      warehouse = "Import";
    }
    if (!job_type && warehouse == "Import") {
      setSearchParams({ job_type: "EJO" }, { replace: true });
      job_type = "EJO";
    }

    if (!job_type && warehouse == "Export") {
      setSearchParams({ job_type: "SJO" }, { replace: true });
      job_type = "SJO";
    }
    setWarehouse(warehouse);
    setJobType(job_type);
  }, []);

  useEffect(() => {
    if (Warehouse && jobType) {
      // setJobType(Warehouse === "Import"?"EJO":"SJO")
      setSearchParams(
        {
          warehouse: Warehouse,
          job_type:
            Warehouse === "Import"
              ? "EJO"
              : jobType !== "EJO"
              ? jobType ?? "SJO"
              : "SJO",
        },
        { replace: true }
      );
      GetData();
    }
  }, [Warehouse,jobTypeFilter]);

  const GetData = async (page = 1) => {
    setLoading(true);

    let url = `https://ctas.live/backend/api/warehouse/jobs?warehouse=${Warehouse}&page=${page}`;
    if (jobTypeFilter) {
      url += `&status=${jobTypeFilter}`;
    }

    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setData(response.data.data);
      } else {
        setData([]);
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="sk-chase-dot" />
            ))}
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="text-primary">Warehouse Jobs</h3>
                  </div>
                  <div className="col-md-12">
                    <div className="d-flex align-items-center gap-3 mb-2">
                      <button
                        onClick={() => {
                          setWarehouse("Import");
                          setJobTypeFilter("1");
                        }}
                        className={`btn ${
                          Warehouse === "Import"
                            ? "btn-info"
                            : "btn-outline-info"
                        }`}
                      >
                        Import Warehouse Jobs
                      </button>
                      <button
                        onClick={() => {
                          setWarehouse("Export");
                          setJobTypeFilter("1");
                        }}
                        className={`btn ${
                          Warehouse === "Export"
                            ? "btn-info"
                            : "btn-outline-info"
                        }`}
                      >
                        Export Warehouse Jobs
                      </button>
                    </div>

                    <div className="d-flex align-items-center gap-3 mb-2">
                      <div className="btn-group" role="group">
                        <button
                          type="button"
                          className={`btn btn-sm ${
                            jobTypeFilter == "1"
                              ? "btn-primary"
                              : "btn-outline-primary"
                          }`}
                          onClick={() => setJobTypeFilter("1")}
                        >
                          Active
                        </button>
                        <button
                          type="button"
                          className={`btn btn-sm ${
                            jobTypeFilter == "2"
                              ? "btn-primary"
                              : "btn-outline-primary"
                          }`}
                          onClick={() => setJobTypeFilter("2")}
                        >
                          Completed
                        </button>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-body px-1">
                        <div className="table-responsive text-nowrap">
                          <table className="table table-hover table-font table-striped">
                            <thead >
                              <tr className="table-primary text-center">
                                <th>S.No.</th>
                                <th>Job Type</th>
                                <th>CTR No</th>
                                <th>CTR Size</th>
                                <th>CTR Type</th>
                                <th>Loaded/Empty</th>
                                <th>FCL/LCL</th>
                                <th>Source</th>
                              {Warehouse=='Export' &&(
                                <th>JOB No</th>
                              )} 
                              {jobTypeFilter=='2' &&(
                                <th>JOB Compliance Datetime</th>
                              )}
                              </tr>
                            </thead>
                            <tbody>
                              {Data?.data?.map((data, key) => (
                                <tr key={data.rn}>
                                  <td>{data.rn}</td>
                                  <td>{data.job_type}</td>
                                  <td>{data.container_no}</td>
                                  <td>{data.container_size}</td>
                                  <td>{data.container_type}</td>
                                  <td>
                                    {data?.ldd_mt_flg === "L"
                                      ? "Loaded"
                                      : "Empty"}
                                  </td>
                                  <td>{data?.flc_lcl_flg}</td>
                                  <td>{data?.icd_location}</td>
                                  {Warehouse=='Export' &&(
                                 <td>{data?.job_no}</td>
                              )} 
                                  {jobTypeFilter=='2' &&(
                                <td>{formatToDateTime(data?.yard_tran?.created_at)}</td>
                              )}
                                 
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          {Data && Data.data && (
                            <div className="container mt-4">
                              <div className="row">
                                <div className="col-sm-12 col-md-6">
                                  <div
                                    className="dataTables_info"
                                    id="DataTables_Table_0_info"
                                    role="status"
                                    aria-live="polite"
                                  >
                                    Showing {Data.from} to {Data.to} of{" "}
                                    {Data.total} entries
                                  </div>
                                </div>
                                <div className="col-10 m-auto mt-2">
                                  <div
                                    className="dataTables_paginate paging_simple_numbers"
                                    id="DataTables_Table_0_paginate"
                                  >
                                    <ul className="pagination ">
                                      {Data &&
                                        Data.links &&
                                        Data.links.map((link, q) => {
                                          let showData =
                                            Data.links.length == q + 1
                                              ? "Next"
                                              : q == 0
                                              ? "Previous"
                                              : link.label;
                                          return (
                                            <li
                                              key={q}
                                              className={`paginate_button page-item ${
                                                link.active === true
                                                  ? "active"
                                                  : ""
                                              }  ${
                                                showData == "Next" &&
                                                Data.current_page ==
                                                  Data.last_page
                                                  ? "disabled"
                                                  : showData == "Previous" &&
                                                    Data.current_page == 1
                                                  ? "disabled"
                                                  : ""
                                              } `}
                                            >
                                              <button
                                                onClick={() => {
                                                  showData == "Previous"
                                                    ? GetData(
                                                        Data.current_page - 1
                                                      )
                                                    : showData == "Next"
                                                    ? GetData(
                                                        Data.current_page + 1
                                                      )
                                                    : GetData(link.label);
                                                }}
                                                aria-controls="DataTables_Table_0"
                                                role="link"
                                                aria-current="page"
                                                data-dt-idx={0}
                                                tabIndex={0}
                                                className="page-link"
                                              >
                                                {showData}
                                              </button>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
